import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useApiClient } from "../../../apiClient";
import { primeQueryCache } from "../../../utils/primeQueryCache";
import { ProductDto } from "../../../models/product/dto/product.dto";
import { GET_PRODUCT_QUERY_KEY } from "./useGetProduct";

export const GET_PRODUCTS_QUERY_KEY = (locationId?: string) => ['products', locationId];

export const useListProducts = (locationId?: string) => {
    const client = useApiClient();
    const queryClient = useQueryClient();

    const endpoint = locationId ? `products?locationId=${locationId}` : 'products';

    return useQuery({
        queryKey: GET_PRODUCTS_QUERY_KEY(locationId),
        queryFn: () => client.fetchApi<ProductDto[], {}>({ endpoint, method: 'GET' }),
        staleTime: 30_000,
        onSuccess: (data: ProductDto[]) => {
            // O(items), not O(items × cache) — see primeQueryCache for the org-switch freeze this loop was part of.
            primeQueryCache(queryClient, (item) => GET_PRODUCT_QUERY_KEY(item.id), data);
        },
    });
};
